import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from "react";
import { Drawer, Grid, Typography, Chip, makeStyles, Button, Divider } from "@material-ui/core";
import * as Yup from "yup";
import { Formik, Form, Field, FieldArray } from "formik";
import { TextField } from "formik-material-ui";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import { SearchSelect, SubmitButton, Can } from "../../../../..";
import _ from "lodash";
import { Debug } from "../../../../Forms/Debug";
var useStyles = makeStyles(function (theme) {
  return {
    drawerContainer: {
      padding: "24px",
      width: "380px"
    },
    chip: {
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent",
      margin: "8px"
    },
    title: {
      margin: "16px 0 8px 0"
    },
    card: {
      padding: "8px",
      borderRadius: "5px",
      border: "1px solid #999",
      color: "#fff",
      background: "transparent"
    },
    cardText: {
      marginTop: "8px"
    },
    cardIconText: {
      marginTop: "8px",
      display: "flex",
      alignItems: "center"
    },
    actions: {
      display: "flex",
      justifyContent: "flex-end",
      marginBottom: "24px"
    },
    mr30: {
      marginRight: "30px"
    },
    icon: {
      margin: "8px"
    },
    mt8: {
      marginTop: "8px"
    },
    divider: {
      margin: "4px 0"
    },
    containerDelete: {
      height: "100vh",
      display: "flex",
      alignItems: "center"
    },
    alignCenter: {
      width: "100%",
      textAlign: "center"
    },
    iconDelete: {
      fontSize: "128px",
      textAlign: "center",
      width: "100%"
    },
    iconStaff: {
      fontSize: "80px",
      textAlign: "center",
      width: "100%"
    },
    iconActions: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificate: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center"
    },
    certificateLink: {
      textDecoration: "none",
      color: "inherit"
    },
    text: {
      fontFamily: theme.typography.fontFamily
    }
  };
});

var CampusSingleDrawerStaff = function CampusSingleDrawerStaff(props) {
  var _useState = useState("view"),
      _useState2 = _slicedToArray(_useState, 2),
      type = _useState2[0],
      setType = _useState2[1];

  var classes = useStyles();

  var toggleDrawer = function toggleDrawer() {
    setType("view");
    props.toggleDrawer();
  };

  var renderDrawerContent = function renderDrawerContent() {
    var content;

    switch (type) {
      case "view":
        content = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h5",
          align: "center"
        }, props.staff && props.staff.name)), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(AccountCircleIcon, {
          className: classes.iconStaff
        })), /*#__PURE__*/React.createElement(Can, {
          role: props.role,
          perform: "campus:edit_staff",
          data: {
            role: props.role,
            userRole: props.staff ? props.staff.role : null
          },
          yes: function yes() {
            return /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.iconActions
            }, props.isEditable && /*#__PURE__*/React.createElement(EditIcon, {
              style: {
                color: "#ffe082"
              },
              className: classes.icon,
              onClick: function onClick() {
                setType("edit");
              }
            }), /*#__PURE__*/React.createElement(DeleteIcon, {
              color: "secondary",
              className: classes.icon,
              onClick: function onClick() {
                setType("delete");
              }
            }));
          },
          no: function no() {
            return null;
          }
        }), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body1",
          align: "center"
        }, props.staff && props.staff.role && props.translation ? props.translation.roles ? props.translation.roles[props.staff.role] || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.personal_info || "Personal Info" : "Personal Info"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.email || "Email: " : "Email:", " ").concat(props.staff ? props.staff.email : "")), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2"
        }, "".concat(props.translation ? props.translation.phone || "Telephone: " : "Telephone:", " ").concat(props.staff ? props.staff.phone : ""))), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.groups || "Groups" : "Groups"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.staff && props.staff.groups && props.staff.groups.map(function (group) {
          return /*#__PURE__*/React.createElement(Chip, {
            key: "campus-drawer-staff-group-".concat(group._id),
            label: group.name,
            className: classes.chip
          });
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.sports || "Sports" : "Sports"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.staff && props.staff.sports && props.staff.sports.map(function (sport, index) {
          return /*#__PURE__*/React.createElement(Chip, {
            key: "campus-drawer-staff-sport-".concat(index),
            label: sport,
            className: classes.chip
          });
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12,
          className: classes.title
        }, /*#__PURE__*/React.createElement(Typography, {
          variant: "h6"
        }, props.translation ? props.translation.certificates || "Certificates" : "Certificates"), /*#__PURE__*/React.createElement(Divider, {
          className: classes.divider
        })), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, props.staff && props.staff.certificates && props.staff.certificates.map(function (certificate, index) {
          return /*#__PURE__*/React.createElement("div", {
            className: classes.certificate
          }, /*#__PURE__*/React.createElement("span", {
            className: [classes.text, classes.mr30].join(" ")
          }, certificate.name), /*#__PURE__*/React.createElement(RemoveRedEye, {
            fontSize: "small",
            onClick: function onClick() {
              props.handleViewCertificate(certificate.fileRoute).then(function (link) {
                // console.log("link", link);
                window.open(link, "_blank");
              });
            }
          }));
        })));
        break;

      case "edit":
        var initialValues = props.staff ? _objectSpread(_objectSpread({}, props.staff), {}, {
          groups: props.staff.groups.map(function (group) {
            return group._id;
          })
        }) : {
          groups: []
        };
        var staffSchema = Yup.object().shape({
          groups: Yup.array()
        });
        content = /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(Formik, {
          initialValues: initialValues,
          validationSchema: staffSchema,
          onSubmit: function onSubmit(values) {
            toggleDrawer();
            var groups = {
              addTo: _.difference(values.groups, initialValues.groups),
              removeFrom: _.difference(initialValues.groups, values.groups)
            };

            var objectSubmit = _objectSpread(_objectSpread({}, values), {}, {
              groups: groups
            }); // console.log(objectSubmit);


            props.handleEditStaff(objectSubmit);
          },
          render: function render(_ref) {
            var values = _ref.values,
                isValid = _ref.isValid,
                isSubmitting = _ref.isSubmitting;
            return /*#__PURE__*/React.createElement(Form, null, /*#__PURE__*/React.createElement(Grid, {
              container: true,
              spacing: 2
            }, /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h5",
              align: "center"
            }, props.staff && props.staff.name)), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(AccountCircleIcon, {
              className: classes.iconStaff
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body1",
              align: "center"
            }, props.staff && props.staff.role && props.translation ? props.translation.roles ? props.translation.roles[props.staff.role] || "" : "" : "")), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.title
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.personal_info || "Personal Info" : "Personal Info"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "body2"
            }, "".concat(props.translation ? props.translation.email || "Email: " : "Email:", " ").concat(props.staff ? props.staff.email : "")), /*#__PURE__*/React.createElement(Typography, {
              variant: "body2"
            }, "".concat(props.translation ? props.translation.phone || "Telephone: " : "Telephone:", " ").concat(props.staff ? props.staff.phone : ""))), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.title
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.groups || "Groups" : "Groups"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, /*#__PURE__*/React.createElement(Field, {
              name: "groups",
              key: "groups",
              component: SearchSelect,
              label: props.translation ? props.translation.selects ? props.translation.selects.groups || "Groups" : "Groups" : "Groups",
              options: props.groups ? props.groups.map(function (group) {
                return {
                  label: group.name,
                  value: group._id
                };
              }) : [],
              variant: "outlined",
              isMulti: true
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12,
              className: classes.title
            }, /*#__PURE__*/React.createElement(Typography, {
              variant: "h6"
            }, props.translation ? props.translation.sports || "Sports" : "Sports"), /*#__PURE__*/React.createElement(Divider, {
              className: classes.divider
            })), /*#__PURE__*/React.createElement(Grid, {
              item: true,
              xs: 12
            }, props.staff && props.staff.sports && props.staff.sports.map(function (sport, index) {
              return /*#__PURE__*/React.createElement(Chip, {
                key: "campus-drawer-staff-sport-".concat(index),
                label: sport,
                className: classes.chip
              });
            }))), /*#__PURE__*/React.createElement(Grid, {
              container: true,
              className: classes.actions
            }, /*#__PURE__*/React.createElement(Button, {
              type: "button",
              size: "medium",
              className: classes.mr30,
              color: "secondary",
              variant: "outlined",
              onClick: function onClick() {
                setType("view");
              }
            }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel"), /*#__PURE__*/React.createElement(Button, {
              size: "medium",
              color: "primary",
              variant: "outlined",
              disabled: !isValid || isSubmitting,
              component: SubmitButton,
              type: "submit"
            }, props.translation ? props.translation.buttons ? props.translation.buttons.edit || "Edit" : "Edit" : "Edit")));
          }
        }));
        break;

      case "delete":
        content = /*#__PURE__*/React.createElement(Grid, {
          container: true,
          className: classes.containerDelete,
          alignItems: "center",
          spacing: 2
        }, /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 12
        }, /*#__PURE__*/React.createElement(HighlightOffIcon, {
          color: "secondary",
          className: classes.iconDelete
        }), /*#__PURE__*/React.createElement(Typography, {
          variant: "h6",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_staff ? "".concat(props.translation.texts.delete_staff.title) || "Delete staff" : "Delete staff" : "Delete staff" : "Delete staff"), /*#__PURE__*/React.createElement(Typography, {
          variant: "body2",
          className: classes.alignCenter
        }, props.translation ? props.translation.texts ? props.translation.texts.delete_staff ? props.translation.texts.delete_staff.text ? props.translation.texts.delete_staff.text || "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?" : "Do you want to delete?")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "default",
          onClick: function onClick() {
            setType("view");
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons.cancel || "Cancel" : "Cancel" : "Cancel")), /*#__PURE__*/React.createElement(Grid, {
          item: true,
          xs: 6
        }, /*#__PURE__*/React.createElement(Button, {
          fullWidth: true,
          variant: "contained",
          color: "secondary",
          onClick: function onClick() {
            toggleDrawer();
            props.handleDeleteStaff(props.staff._id);
          }
        }, props.translation ? props.translation.buttons ? props.translation.buttons["delete"] || "Delete" : "Delete" : "Delete")));
        break;

      default:
        content = "";
        break;
    }

    return content;
  };

  return /*#__PURE__*/React.createElement(Drawer, {
    anchor: "right",
    open: props.open,
    onClose: toggleDrawer
  }, /*#__PURE__*/React.createElement(Grid, {
    container: true,
    className: classes.drawerContainer
  }, renderDrawerContent()));
};

export { CampusSingleDrawerStaff };
/* TO IMPLEMENT IN FUTURE */
//   case "edit":
// const initialValues = {
//   name: "",
//   email: "",
//   phone: "",
//   groups: [],
//   sports: [],
//   certificates: []
// };
// let staffSchema = Yup.object().shape({
//   name: Yup.string().required("Campo obligatorio"),
//   email: Yup.string().required("Campo obligatorio"),
//   phone: Yup.string().required("Campo obligatorio"),
//   groups: Yup.array(),
//   sports: Yup.array(),
//   certificates: Yup.string(),
//   responsibles: Yup.array()
// });
// let staff = {
//   ...props.staff,
//   groups: props.staff.groups.map(group => group._id)
// };
// content = (
//   <Grid item xs={12}>
//     <Formik
//       initialValues={staff || initialValues}
//       validationSchema={staffSchema}
//       onSubmit={values => {
//         toggleDrawer();
//         props.handleEditStaff(values);
//       }}
//       render={({ values, isValid, isSubmitting }) => {
//         return (
//           <Form>
//             <Grid container spacing={2}>
//               <Grid item xs={12}>
//                 <Field
//                   component={TextField}
//                   label={
//                     props.translation
//                       ? props.translation.inputs
//                         ? props.translation.inputs.name || "Name"
//                         : "Name"
//                       : "Name"
//                   }
//                   name="name"
//                   variant="outlined"
//                   fullWidth
//                   margin="normal"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Field
//                   component={TextField}
//                   label={
//                     props.translation
//                       ? props.translation.inputs
//                         ? props.translation.inputs.email || "Email"
//                         : "Email"
//                       : "Email"
//                   }
//                   name="email"
//                   variant="outlined"
//                   fullWidth
//                   margin="normal"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Field
//                   component={TextField}
//                   label={
//                     props.translation
//                       ? props.translation.inputs
//                         ? props.translation.inputs.phone || "Telephone"
//                         : "Telephone"
//                       : "Telephone"
//                   }
//                   name="phone"
//                   variant="outlined"
//                   fullWidth
//                   margin="normal"
//                 />
//               </Grid>
//               <Grid item xs={12}>
//                 <Field
//                   name="groups"
//                   key="groups"
//                   component={SearchSelect}
//                   label={
//                     props.translation
//                       ? props.translation.selects
//                         ? props.translation.selects.groups || "Groups"
//                         : "Groups"
//                       : "Groups"
//                   }
//                   options={props.groups.map(group => {
//                     return { label: group.name, value: group._id };
//                   })}
//                   variant="outlined"
//                   isMulti
//                 />
//               </Grid>
//               {/* TODO Add Sports array */}
//               {/* TODO Add Certificates */}
//             </Grid>
//             <Grid container className={classes.actions}>
//               <Button
//                 type="button"
//                 size="medium"
//                 className={classes.mr30}
//                 color="secondary"
//                 variant="outlined"
//                 onClick={() => {
//                   setType("view");
//                 }}
//               >
//                 {props.translation
//                   ? props.translation.buttons
//                     ? props.translation.buttons.cancel || "Cancel"
//                     : "Cancel"
//                   : "Cancel"}
//               </Button>
//               <Button
//                 size="medium"
//                 color="primary"
//                 variant="outlined"
//                 disabled={!isValid || isSubmitting}
//                 component={SubmitButton}
//                 type="submit"
//               >
//                 {props.translation
//                   ? props.translation.buttons
//                     ? props.translation.buttons.edit || "Edit"
//                     : "Edit"
//                   : "Edit"}
//               </Button>
//             </Grid>
//             {/* <Debug /> */}
//           </Form>
//         );
//       }}
//     />
//   </Grid>
// );
// break;